module.exports = {"340202012":"方村街道","340202013":"张家山街道","340202014":"赭麓街道","340202015":"范罗山街道","340202016":"赭山街道","340202017":"弋矶山街道","340202018":"汀棠街道","340202019":"天门山街道","340202020":"大砻坊街道","340202021":"荆山街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340202.json
// module id = 1150
// module chunks = 0